<div class="modal-header">
  <h4 class="modal-title">Session Timeout</h4>
</div>
<div class="modal-body">
  <p>
    Your session is about to expire due to inactivity.<br />
    Would you like to extend your session or log out?
  </p>
  <p *ngIf="unsavedWorkService.unsavedWork()" class="warning-text">
    You have unsaved work. If you log out now, your changes may be lost.
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-success" (click)="extendSession()" ngbAutofocus>
    Extend Session
  </button>
  <button type="button" class="btn btn-danger" (click)="logout()">Logout</button>
</div>
